const shouldShow = (state, view) => {
  const { from, to } = view.state.selection;
  const text = state.doc.textBetween(from, to, '');
  return Boolean(text.trim().length);
};

export default shouldShow;
